import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiTwitter, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-indigo-700 rounded-lg flex items-center justify-center text-white">
                <span className="font-playfair text-xl font-bold">M</span>
              </div>
              <span className="font-playfair text-2xl font-bold text-white tracking-tight">
                Massage <span className="text-indigo-400">World</span>
              </span>
            </Link>
            <p className="text-stone-400 max-w-sm text-lg leading-relaxed">
              The premier directory for discovering professional massages, day spas, and wellness centers across Charlotte, North Carolina.
            </p>
            <div className="flex space-x-6 mt-8">
              <a href="#" className="text-stone-500 hover:text-white transition-colors">
                <SafeIcon icon={FiInstagram} className="h-6 w-6" />
              </a>
              <a href="#" className="text-stone-500 hover:text-white transition-colors">
                <SafeIcon icon={FiTwitter} className="h-6 w-6" />
              </a>
              <a href="#" className="text-stone-500 hover:text-white transition-colors">
                <SafeIcon icon={FiFacebook} className="h-6 w-6" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-6">Explore</h4>
            <ul className="space-y-4">
              <li><Link to="/" className="hover:text-indigo-400 transition-colors">Directory</Link></li>
              <li><Link to="/neighborhoods" className="hover:text-indigo-400 transition-colors">Neighborhoods</Link></li>
              <li><Link to="/deals" className="hover:text-indigo-400 transition-colors">Current Deals</Link></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Wellness Blog</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-6">Business</h4>
            <ul className="space-y-4">
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Add Your Listing</a></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Advertising</a></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Owner Portal</a></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Support</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-stone-800 mt-20 pt-10 text-sm text-stone-500 flex flex-col md:flex-row justify-between items-center">
          <p>&copy; {new Date().getFullYear()} Massage World Charlotte. All rights reserved.</p>
          <div className="space-x-8 mt-6 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;